import { render, staticRenderFns } from "./TransationDetailOPGeneral.vue?vue&type=template&id=42bd6128&"
import script from "./TransationDetailOPGeneral.vue?vue&type=script&lang=js&"
export * from "./TransationDetailOPGeneral.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports